import { render, staticRenderFns } from "./AddProjectTask.vue?vue&type=template&id=c3cfda50&scoped=true&"
import script from "./AddProjectTask.vue?vue&type=script&setup=true&lang=js&"
export * from "./AddProjectTask.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3cfda50",
  null
  
)

export default component.exports